import { Record, List } from 'immutable'

import { FavoriteActivityRecord } from 'store/records/favoriteActivity'

export class DifferentActivity extends FavoriteActivityRecord {}

export const Loaded = Record({
  favorite: false,
  previous: false,
  upcoming: false,
})

export const DifferentActivities = Record({
  favorite: List(),
  previous: List(),
  upcoming: List(),
  loaded: new Loaded(),
  pending: false,
})
